import React, {
  Component,
} from "react";
import moment from "moment";
import {
  Spin,
} from "antd";
// 接口以及调用接口方法
import { powerlossTrend } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// 组件
import NoData from "@/components/common/no_data";
import Echarts from "echarts";
// 图片
import legend1 from "@/assets/img/displayBoard/ds1.svg";
import legend2 from "@/assets/img/displayBoard/ds2.svg";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

// eslint-disable-next-line arrow-parens
@connect(state => state)
class ElecticalLossLine extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.chartId = this.props.chartId ? this.props.chartId : ""; // 设置电损折线图 id
    this.state = {
      showSping: true, // loading加载是否显示：true，显示，false，不显示
      noData: false, // 是否有数据
      param: {
        cityIds: this.props.param.cityIds,
        isMonth: this.props.param.isMonth,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      lineData: [],
    };
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds
        && nextProps.param.isMonth === this.state.param.isMonth
        && nextProps.param.cityIds === this.state.param.cityIds
        && nextProps.param.operationProperty === this.state.param.operationProperty
        && nextProps.param.operationMode === this.state.param.operationMode
        && nextProps.param.date === this.state.param.date
    ) {
      // console.log("电损数据一样");
    } else {
      // console.log("电损数据不一样");
      this.setState(
        {
          showSping: true,
          param: {
            cityIds: nextProps.param.cityIds,
            isMonth: nextProps.param.isMonth,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          this.getIntactRate();
        },
      );
    }
  }

  // 数据格式化方法
  formatterDate(value) {
    // 判断value 是正数还是复数
    const valueInt = parseInt(value);
    const flag1 = valueInt < 0; // value是否为负数
    const flag2 = flag1 ? valueInt < -100000 : valueInt > 100000; // 判断value位数 是否大于十万位
    const flag3 = flag1 ? valueInt < -1000000000 : valueInt > 1000000000; // 判断value位数 是否大于十亿位
    const flag4 = flag1 ? valueInt < -100000000000 : valueInt > 100000000000; // 判断value位数，是否大于千亿
    const flag5 = flag1
      ? valueInt < -100000000000000 : valueInt > 100000000000000; // 判断value位数，是否大于百万亿
    if (flag5) {
      return `${parseInt(valueInt / 1000000000000)}T`;
    } else if (flag4) {
      return `${parseInt(valueInt / 1000000000)}B`;
    } else if (flag3) {
      return `${parseInt(valueInt / 1000000)}M`;
    } else if (flag2) {
      return `${parseInt(valueInt / 1000)}K`;
    } else {
      return valueInt;
    }
  }

  componentDidMount() {
    this.getIntactRate();
  }

  // 获取数据
  getIntactRate() {
    // 获取成功率趋势数据
    fetchHandler(powerlossTrend, {
      startTime: this.state.param.date,
      isMonth: this.state.param.isMonth,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      // console.log(res);
      if (res.data) {
        this.setState({
          showSping: false,
          lineData: [...res.data],
          noData: !res.data.length > 0,
        }, () => {
          this.renderChart();
        });
      }
    });
  }

  renderChart() {
    window.removeEventListener("resize", () => {});
    const { lineData } = this.state;
    // 假数据
    const xAxisData = [];
    const workingData = [];
    const theoryData = [];
    // 折线图数据设置
    lineData.map((item) => {
      xAxisData.push(moment(item.date).format("MM.DD"));
      workingData.push({
        value: item.actualLossPowerRate,
        info: {
          meterPower: item.meterPower,
          actualLossPower: item.actualLossPower,
        },
      });
      theoryData.push(item.theoryLossPowerRate);
      return true;
    });

    const myChart = Echarts.init(document.getElementById("electicalLossLine"));
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        show: true,
        formatter: (params) => {
          let str = "";
          if (params[0].axisValue) {
            str += `<div  style="padding:10px 24px 3px 10px">${params[0].axisValue}</div>`;
            str += `<div  style="padding:3px 24px 3px 10px">总电量：${this.formatterDate(params[0].data.info.meterPower)}，电损电量：${this.formatterDate(params[0].data.info.actualLossPower)}</div>`;
            str += `<div  style="padding:3px 24px 12px 10px">运行电损率：${params[0].data.value}%，理论电损率：${params[1].data}%</div>`;
            return str;
          }
        },
        position: function (pos, params, dom, rect, size) {
          // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
          const obj = { top: 60 };
          obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 5;
          return obj;
        },
      },
      color: ["#23B899", "#76A5F7", "#EB7F66", "#EB7F66"],
      legend: {
        selectedMode: false,
        textStyle: {
          padding: [10, 0],
        },
        itemGap: 15,
        itemWidth: 21,
        itemHeight: 8,
        data: [{
          name: "运行电损率",
          icon: `image://${legend2}`,
        }, {
          name: "理论电损率",
          icon: `image://${legend1}`,
        }],
        top: 0,

      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisTick: {
            alignWithLabel: true,
            color: "#C4C6CF",
          },
          axisLine: {
            lineStyle: {
              color: "#C4C6CF",
            },
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            textStyle: {
              color: "#666666",
            },
          },
        },
      ],
      grid: {
        left: "50px",
        right: "0px",
        bottom: "44px",
      },
      yAxis: [{
        type: "value",
        name: "",
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: {
          textStyle: {
            color: "#666666",
          },
          formatter: "{value} %",
        },
      }],
      toolbox: {
        feature: {
          dataZoom: {
            yAxisIndex: 'none'
          },
          restore: {},
          saveAsImage: {}
        }
      },
      dataZoom: [
        {
          type: 'inside',
          start: 0,
          end: 20
        },
        {
          start: 0,
          end: 20
        }
      ],
      series: [{
        name: "运行电损率",
        type: "line",
        yAxisIndex: 0,
        symbol: "emptyCircle",
        symbolSize: 1,
        showSymbol: false,
        data: workingData,
        smooth: true,
      }, {
        name: "理论电损率",
        type: "line",
        symbol: "emptyCircle",
        symbolSize: 1,
        showSymbol: false,
        yAxisIndex: 0,
        data: theoryData,
        smooth: true,
      }],
    };
    myChart.clear();
    myChart.setOption(option);
    window.addEventListener("resize", () => {
      console.log(this.props.panelsInfo.activeKey);
      if (this.props.panelsInfo.activeKey === "0001") {
        myChart.resize();
      }
    });
  }

  render() {
    const content = (

      <Spin tip="加载中..." spinning={this.state.showSping}>
        <div className="exception-line-chart">
          <div className="line" id="electicalLossLine"></div>
        </div>
        {this.state.noData ? (
          <div className="no_data_com no_data_line">
            <NoData />
          </div>) : null}
      </Spin>
    );

    return content;
  }
}

export default injectIntl(ElecticalLossLine);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/electicalLossLine.js